import React from 'react';

const sixteenByNines = [
  <>
    <g clipPath="url(#clip0_3827_50798)">
      <path d="M0 8C0 3.58172 3.58172 0 8 0H250C254.418 0 258 3.58172 258 8V449C258 453.418 254.418 457 250 457H8C3.58173 457 0 453.418 0 449V8Z" fill="#EFEFEF" />
      <mask id="mask0_3827_50798" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-277" y="36" width="671" height="684">
        <rect x="-276.297" y="209.026" width="249.026" height="707.255" transform="rotate(-43.8332 -276.297 209.026)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask0_3827_50798)">
        <rect x="-276.296" y="209.026" width="249.026" height="707.255" transform="rotate(-43.8332 -276.296 209.026)" fill="#FFAB00" />
        <g style={{ mixBlendMode: 'lighten' }}>
          <path d="M300.313 -23.4909L521.733 188.79L131.56 595.76L-89.8593 383.479C-89.8593 383.479 -94.2702 308.922 20.8292 242.708C135.929 176.494 300.313 -23.4909 300.313 -23.4909Z" fill="#99D1FF" />
        </g>
      </g>
      <mask id="mask1_3827_50798" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-161" y="-238" width="723" height="734">
        <rect x="-160.151" y="-14.6033" width="321.416" height="707.255" transform="rotate(-43.8332 -160.151 -14.6033)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_50798)">
        <rect x="-239.611" y="-14.6033" width="386.061" height="707.255" transform="rotate(-43.8332 -239.611 -14.6033)" fill="#99D1FF" />
        <path d="M309.144 -23.4899L530.563 188.791L140.391 595.761L-124.839 322.166C-124.839 322.166 7.58366 260.366 122.357 172.081C237.13 83.7958 309.144 -23.4899 309.144 -23.4899Z" fill="#FFD666" />
        <g style={{ mixBlendMode: 'multiply' }}>
          <circle cx="329.829" cy="423.694" r="251.613" fill="#FCA9A1" />
        </g>
        <rect x="-177.812" y="-4.48999" width="238.37" height="423.769" fill="#002B93" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_50798">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H250C254.418 0 258 3.58172 258 8V449C258 453.418 254.418 457 250 457H8C3.58173 457 0 453.418 0 449V8Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46785)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46785" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-362" y="104" width="1314" height="724">
        <rect x="-256.59" y="827.378" width="438.181" height="1244.47" transform="rotate(-103.833 -256.59 827.378)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask0_3827_46785)">
        <rect x="-294.051" y="830.958" width="438.181" height="1244.47" transform="rotate(-103.833 -294.051 830.958)" fill="#452CAB" />
        <path d="M-245.714 547.945L228.106 561.695L546.562 173.333L652.59 624.468L-155.224 859.27C-155.224 859.27 -307.642 873.171 -229.971 774.27C-152.299 675.369 -245.714 547.945 -245.714 547.945Z" fill="#FFD666" />
      </g>
      <mask id="mask1_3827_46785" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-652" y="-388" width="1344" height="848">
        <rect x="-516.399" y="459.33" width="565.556" height="1244.47" transform="rotate(-103.833 -516.399 459.33)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46785)">
        <rect x="-689.118" y="586.777" width="679.304" height="1244.47" transform="rotate(-103.833 -689.118 586.777)" fill="#FFD666" />
        <path d="M-23.8611 -263.617L494.422 -414.263L771.31 538.344L121.05 701.805C121.05 701.805 147.266 438.914 113.71 186.346C80.1541 -66.2228 -23.8611 -263.617 -23.8611 -263.617Z" fill="#FFAB00" />
        <ellipse cx="477.165" cy="-257.63" rx="459.048" ry="470.728" transform="rotate(-60 477.165 -257.63)" fill="#A081F4" />
        <path d="M-574.506 409.147L-216.625 116.182L317.962 398.143L71.2494 781.974L-574.506 409.147Z" fill="#A081F4" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46785">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46807)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46807" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-113" y="-233" width="635" height="647">
        <rect x="521.223" y="250.36" width="235.577" height="669.057" transform="rotate(136.167 521.223 250.36)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask0_3827_46807)">
        <rect x="518.494" y="275.189" width="235.577" height="669.057" transform="rotate(136.167 518.494 275.189)" fill="#FFC63F" />
        <g style={{ mixBlendMode: 'lighten' }}>
          <path d="M-24.246 470.319L-233.707 269.504L135.393 -115.487L344.854 85.3285C344.854 85.3285 349.027 155.859 240.144 218.497C131.261 281.135 -24.246 470.319 -24.246 470.319Z" fill="#FFC63F" />
        </g>
      </g>
      <mask id="mask1_3827_46807" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-263" y="-13" width="683" height="694">
        <rect x="419.701" y="470.263" width="304.057" height="669.057" transform="rotate(136.167 419.701 470.263)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46807)">
        <rect x="494.87" y="470.263" width="365.211" height="669.057" transform="rotate(136.167 494.87 470.263)" fill="#48DC37" />
        <path d="M-24.2478 478.67L-233.709 277.854L135.391 -107.137L386.296 151.682C386.296 151.682 256.847 210.144 148.273 293.661C39.6979 377.178 -24.2478 478.67 -24.2478 478.67Z" fill="#0FBB0C" />
        <circle cx="-185.793" cy="222.67" r="238.024" transform="rotate(-180 -185.793 222.67)" fill="#FFC63F" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46807">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46829)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46829" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-425" y="-247" width="782" height="766">
        <rect x="158.927" y="-246.562" width="284.662" height="808.464" transform="rotate(46.1668 158.927 -246.562)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask0_3827_46829)">
        <rect x="159.438" y="-207.587" width="414.677" height="808.464" transform="rotate(46.1668 159.438 -207.587)" fill="#FFC63F" />
        <g style={{ mixBlendMode: 'lighten' }}>
          <path d="M634.194 304.498L237.227 718.556L-283.149 219.659L113.819 -194.399C113.819 -194.399 231.572 -223.424 300.988 -60.3455C370.404 102.733 634.194 304.498 634.194 304.498Z" fill="#7D58EE" />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <rect x="-121.781" y="-113.801" width="292.665" height="484.411" fill="#002B93" />
        </g>
      </g>
      <mask id="mask1_3827_46829" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-169" y="-114" width="839" height="826">
        <rect x="414.558" y="-113.793" width="367.411" height="808.464" transform="rotate(46.1668 414.558 -113.793)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46829)">
        <rect x="414.558" y="-204.625" width="441.307" height="808.464" transform="rotate(46.1668 414.558 -204.625)" fill="#99D1FF" />
        <g style={{ mixBlendMode: 'multiply' }}>
          <path d="M606.371 422.657L363.713 675.762L-101.495 229.755L363.713 -103.709C363.713 -103.709 281.895 82.9917 382.814 214.189C483.733 345.387 606.371 422.657 606.371 422.657Z" fill="#006CFF" />
        </g>
        <path d="M302.079 754.105L246.814 830.402L-293.345 312.539L175.926 113.269C175.926 113.269 25.7037 322.088 145.654 471.531C265.605 620.975 302.079 754.105 302.079 754.105Z" fill="#FFAB00" />
        <path d="M334.913 259.6C241.576 259.6 170.882 188.123 170.882 112.879C170.882 37.6354 241.576 -12.8816 334.913 -12.8816C428.25 -12.8816 503.915 48.1154 503.915 123.359C503.915 198.603 428.25 259.6 334.913 259.6Z" fill="#FCA9A1" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46829">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46852)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46852" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-259" y="-128" width="542" height="860">
        <rect x="282.973" y="645.397" width="361.567" height="795.604" transform="rotate(166.167 282.973 645.397)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask0_3827_46852)">
        <rect x="394.248" y="755.818" width="434.287" height="795.604" transform="rotate(166.167 394.248 755.818)" fill="#F87173" />
        <path d="M-179.216 231.198L-275.526 -100.147L333.488 -277.165L437.991 138.555C437.991 138.555 269.921 121.794 108.451 143.247C-53.0191 164.7 -179.216 231.198 -179.216 231.198Z" fill="#FFAB00" />
        <path d="M48.0662 490.709L-318.669 254.715L-212.522 -157.416L205.579 -9.79501L48.0662 490.709Z" fill="#FFC63F" />
      </g>
      <g style={{ mixBlendMode: 'multiply' }}>
        <ellipse cx="117.437" cy="35.5262" rx="293.475" ry="300.942" transform="rotate(-150 117.437 35.5262)" fill="#FFAB00" />
      </g>
      <mask id="mask1_3827_46852" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="19" y="-295" width="519" height="849">
        <rect x="537.22" y="466.118" width="298.452" height="795.604" transform="rotate(163.029 537.22 466.118)" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46852)">
        <rect x="490.768" y="503.247" width="280.134" height="795.604" transform="rotate(166.167 490.768 503.247)" fill="#5F40CC" />
        <ellipse cx="144.824" cy="214.117" rx="114.211" ry="119.176" fill="#FCA9A1" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46852">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46875)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46875" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="214" y="-11" width="348" height="481">
        <rect x="214.769" y="-10.3792" width="347.039" height="479.731" fill="#7D58EE" />
      </mask>
      <g mask="url(#mask0_3827_46875)">
        <rect x="214.769" y="-10.3792" width="347.039" height="479.731" fill="#452CAB" />
        <circle cx="235.183" cy="203.969" r="163.313" fill="#7AED5F" />
      </g>
      <mask id="mask1_3827_46875" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-133" y="-42" width="348" height="481">
        <rect x="-132.271" y="-41.0002" width="347.039" height="479.731" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46875)">
        <rect x="-132.271" y="-41.0002" width="347.039" height="479.731" fill="#5F40CC" />
        <rect x="-132.271" y="-41.0002" width="347.039" height="479.731" fill="#7AED5F" />
        <circle cx="235.182" cy="203.969" r="163.313" fill="#FFC63F" />
      </g>
      <mask id="mask2_3827_46875" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-316" y="78" width="684" height="664">
        <rect x="-315.28" y="381.747" width="395.471" height="559.955" transform="rotate(-50 -315.28 381.747)" fill="#7AED5F" />
      </mask>
      <g mask="url(#mask2_3827_46875)">
        <path d="M-326.205 367.281L-73.8013 66.4785L388.288 443.834L105.264 729.326L-326.205 367.281Z" fill="#FFE799" />
        <rect x="-101.65" y="71.2771" width="173.52" height="479.731" fill="#452CAB" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46875">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46902)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46902" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-249" y="-58" width="381" height="582">
        <path d="M131.834 524L-248.442 468.038L-248.442 -58L131.834 -57.9999L131.834 524Z" fill="#7D58EE" />
      </mask>
      <g mask="url(#mask0_3827_46902)">
        <g style={{ mixBlendMode: 'multiply' }}>
          <path d="M132.096 468.039L-248.442 468.039L-248.442 -57.9999L423.096 -24.4229L132.096 468.039Z" fill="#003EB7" />
        </g>
        <circle cx="20.173" cy="333.731" r="235.038" transform="rotate(-180 20.173 333.731)" fill="#3F98FF" />
        <ellipse cx="165.673" cy="255.385" rx="134.308" ry="134.308" transform="rotate(-180 165.673 255.385)" fill="#FFE799" />
      </g>
      <mask id="mask1_3827_46902" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="123" y="-36" width="379" height="527">
        <path d="M501.442 490.423L123.702 490.423L123.702 -35.6155L501.442 -35.6157L501.442 490.423Z" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46902)">
        <rect x="501.442" y="490.423" width="380.538" height="526.038" transform="rotate(-180 501.442 490.423)" fill="#006CFF" />
        <path d="M501.442 490.423L120.903 490.423L120.903 -35.6156L501.442 -35.6155L501.442 490.423Z" fill="#0FBB0C" />
        <ellipse cx="76.1348" cy="109.885" rx="358.154" ry="358.154" transform="rotate(-90 76.1348 109.885)" fill="#FFAB00" />
        <ellipse cx="120.904" cy="20.3462" rx="358.154" ry="358.154" transform="rotate(-90 120.904 20.3462)" fill="#FFC63F" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46902">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_3827_46932)">
      <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="#EFEFEF" />
      <mask id="mask0_3827_46932" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-204" y="-105" width="956" height="729">
        <path d="M751.84 112.958L531.214 623.49L-204 426.49L-61.5877 -105L751.84 112.958Z" fill="#7D58EE" />
      </mask>
      <g mask="url(#mask0_3827_46932)">
        <path d="M673.724 91.6357L531.214 623.492L-204 426.492L94.4179 -499.504L673.724 91.6357Z" fill="#F87173" />
        <rect x="25.3806" y="-76.3264" width="157.699" height="258.053" fill="#006CFF" />
        <circle cx="444.095" cy="197.768" r="340.088" transform="rotate(105 444.095 197.768)" fill="#FFAB00" />
        <ellipse cx="378.082" cy="18.3225" rx="194.336" ry="194.336" transform="rotate(105 378.082 18.3225)" fill="#FFD666" />
      </g>
      <mask id="mask1_3827_46932" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-118" y="95" width="513" height="321">
        <path d="M-117.679 334.111L-76.5508 95.7083L394.031 176.89L352.904 415.294L-117.679 334.111Z" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_3827_46932)">
        <rect x="-117.679" y="334.111" width="189.602" height="401.773" transform="rotate(-80.212 -117.679 334.111)" fill="#FFE799" />
        <rect x="-118" y="60.0002" width="143" height="469" fill="#002B93" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3827_46932">
        <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H252C256.418 0 260 3.58172 260 8V453C260 457.418 256.418 461 252 461H8C3.58172 461 0 457.418 0 453V8.00001Z" fill="white" />
      </clipPath>
    </defs>
  </>,
];

export default sixteenByNines;
